<template>
    <div>
        <a 
            id="signInGoogleButton" 
            data-user-modal-link-social-authenticate-google
            @click.stop.prevent="startSocialFlow('google')"
            class=""
            href="#" :title="googleTitle"
            style="height: 42.25px"
        >
            <img :src="googleIcon" alt="Google Icon">
            <span class="ml-1">{{ googleText }}</span>
        </a>

        <a 
            data-user-modal-link-social-authenticate-apple 
            @click.stop.prevent="startSocialFlow('apple')"
            class="btn-apple btn-block p-2 d-flex align-items-center justify-content-center border rounded fg-normal fg-normal-hover btn-lg"
            href="#" :title="appleTitle"
            style="height: 42.25px"
        >
            <img :src="appleIcon" alt="Apple Icon">
            <span class="ml-1">{{ appleText }}</span>
        </a>

        <a v-if="true === false" data-user-modal-link-social-authenticate-facebook
            @click.stop.prevent="startSocialFlow('facebook')"
            class="btn-facebook btn-block mt-3 p-2 d-flex align-items-center justify-content-center border fg-white fg-white-hover btn-lg"
            href="#" :title="facebookTitle">
            <i class="fab fa-facebook font-size-125 lh-inherit"></i>
            <span class="ml-1 lh-1">{{ facebookText }}</span>
        </a>
    </div>
</template>

<script>
import { globalLogger } from '../../../../../qaamgo/helper/global-logger';
import { satGlobals } from '../../../../../qaamgo/sat/helper/sat-globals';
import { testIsNonEmptyString } from '../../../../../lib/test-and-assert/test-base';
import { userManager } from '../../../user-manager';
import { pageNotification } from '../../../../../qaamgo/helper/notify';
import { getLocationHashWithoutModalPageFragment } from '../modal-fragment-helper';
import { projectHelper } from '../../../../misc/project-helper';

export default {
    name: 'SocialAuthenticationButtons',
    props: {
        type: {
            type: String,
            required: true,
            validator: function (value) {
                const validTypes = ['login', 'register'];

                return validTypes.includes(value);
            },
        },
        googleTitle: {
            type: String,
            required: true,
        },
        googleText: {
            type: String,
            required: true,
        },
        appleTitle: {
            type: String,
            required: true,
        },
        appleText: {
            type: String,
            required: true,
        },
        facebookTitle: {
            type: String,
            required: true,
        },
        facebookText: {
            type: String,
            required: true,
        },
        reloadPage: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        isOc() {
            return projectHelper.isOnlineConvert();
        },
        googleIcon() {
            return window.sat.googleIcon;
        },
        appleIcon() {
            return window.sat.appleIcon;
        },
    },
    mounted() {
        const script = document.createElement('script')
        script.src = "https://accounts.google.com/gsi/client"
        script.async = true
        script.defer = true
        script.onload = () => {
            google.accounts.id.initialize({
                client_id: window.sat.googleClientId,
            });

            google.accounts.id.renderButton(
                document.getElementById("signInGoogleButton"),
                { 
                    theme: "outline", 
                    size: "large", 
                    width: "400px", 
                    text: this.googleText,
                    logo_alignment: "center"
                }
            );
        }

        document.head.appendChild(script)
    },
    methods: {
        startSocialFlow(provider) {
            // user modal - login attempt - social - start - google
            // user modal - login attempt - social - start - facebook
            // user modal - register attempt - social - start - google
            // user modal - register attempt - social - start - facebook
            globalLogger.log(`user modal - ${this.type} attempt - social - start - ${provider}`);

            const authenticateWindow = satGlobals.getApiUrl('/connect/' + provider + '/authenticate');

            const socialAuthenticationWindow = window.open(authenticateWindow, '_blank');

            this.waitForClosedTab(socialAuthenticationWindow, provider);
        },
        waitForClosedTab(socialAuthenticationWindow, provider) {
            if (!testIsNonEmptyString(provider)) {
                provider = 'unknown';
            }

            if (socialAuthenticationWindow.closed) {
                this.refreshUser(provider);
            } else {
                setTimeout(() => {
                    this.waitForClosedTab(socialAuthenticationWindow, provider);
                }, 500);
            }
        },
        async refreshUser(provider) {
            if (!testIsNonEmptyString(provider)) {
                provider = 'unknown';
            }

            try {
                const user = await userManager.getFreshUser();

                if (user.isAnonymous()) {
                    // user modal - login attempt - social - fail - google
                    // user modal - login attempt - social - fail - facebook
                    // user modal - register attempt - social - fail - google
                    // user modal - register attempt - social - fail - facebook
                    globalLogger.log(
                        `user modal - ${this.type} attempt - social - fail - ${provider}`,
                        'user not authenticated'
                    );

                    this.$emit('auth-fail');

                    return;
                }

                // user modal - login attempt - social - success - google
                // user modal - login attempt - social - success - facebook
                // user modal - register attempt - social - success - google
                // user modal - register attempt - social - success - facebook
                globalLogger.log(`user modal - ${this.type} attempt - social - success - ${provider}`);

                if (this.reloadPage) {
                    window.allowLeave = true;

                    let redirectLink = user.getExtraKey('redirect_after_login');

                    if (testIsNonEmptyString(redirectLink)) {
                        window.location = redirectLink;

                        return;
                    }

                    window.location.hash = getLocationHashWithoutModalPageFragment();

                    window.location.reload();

                    return;
                }

                this.$emit('auth-success');
            } catch (error) {
                // user modal - login attempt - social - fail - google
                // user modal - login attempt - social - fail - facebook
                // user modal - register attempt - social - fail - google
                // user modal - register attempt - social - fail - facebook
                globalLogger.log(`user modal - ${this.type} attempt - social - fail - ${provider}`, error);

                pageNotification.showGenericErrorMessage();
            }
        },
    },
};
</script>
